module.exports = __webpack_public_path__ + "img/logotyp_z_latami_1950-2020.99d2454b.jpg";